function openModalRemove(e, is_direct = true, inputElement = undefined) {
  const element = $(e)
  let elModalRemove = document.querySelector('#modal-remove-cart');
  let elBtnRemoveCart = document.querySelector('#btn-remove-cart-item');
  const qty = element.attr("data-qty");

  if (is_direct) {
    inputElement = $(element.attr('data-id'))
  }
  if (inputElement) {
    elBtnRemoveCart.setAttribute("data-quantity", inputElement.val())
  }

  elBtnRemoveCart.setAttribute("data-id-input", inputElement.attr('id'))

  if (elBtnRemoveCart) {
    elModalRemove.classList.remove('wp-hidden');
    const elPreviewImg = elModalRemove.querySelector('img');
    elPreviewImg.setAttribute('src', element.data("previewImg"));
    elBtnRemoveCart.setAttribute('data-key', element.data("key"));
  }
}

function closeModalRemove() {
  const elModalRemove   = document.querySelector('#modal-remove-cart');
  const elBtnRemoveCart = document.querySelector('#btn-remove-cart-item');
  elModalRemove.classList.add('wp-hidden');
  elBtnRemoveCart.removeAttribute('data-component-key');
  elBtnRemoveCart.removeAttribute('data-component-parent-key');
  elBtnRemoveCart.removeAttribute('data-component-variant-id');
  elBtnRemoveCart.removeAttribute('data-component-index');
  elBtnRemoveCart.removeAttribute('data-key');
  const idInput = elBtnRemoveCart.getAttribute('data-id-input');
  if (idInput) {
    const quantity = elBtnRemoveCart.getAttribute('data-quantity');
    const elInput  = document.querySelector('#' + idInput);
    if (elInput && Number(quantity) <= 0) {
      elInput.value = elInput.getAttribute('data-old-value');
    }
    elBtnRemoveCart.removeAttribute('data-id-input');
    elBtnRemoveCart.removeAttribute('data-quantity');
  }
}

function removeCart() {
  const elModalRemove   = document.querySelector('#modal-remove-cart');
  const elBtnRemoveCart = document.querySelector('#btn-remove-cart-item');
  const componentKey    = elBtnRemoveCart.getAttribute('data-component-key');
  elModalRemove.classList.add('wp-hidden');
  if (componentKey) {
    elBtnRemoveCart.removeAttribute('data-component-key');
    removeBundleComponent();
  } else {
    const itemId = elBtnRemoveCart.dataset.key;
    if (!itemId) return;
    elBtnRemoveCart.removeAttribute('data-key');
    callAPIUpdateCartPageCart(0, itemId);
  }
}

function openPreview(e) {
  const elBtnPreview = document.querySelector('#preview-item-cart');
  const elPreview = document.querySelector('#modal-preview');
  const elImg = elPreview.querySelector('img');
  elImg.setAttribute('src', e.dataset.previewImg);
  elPreview.classList.remove('wp-hidden');
}

function closeModalPreview() {
  const elPreview = document.querySelector('#modal-preview');
  elPreview.classList.add('wp-hidden');
}

function callAPIUpdateCartPageCart(qty, itemId, elementIdToReload) {
  showUIBlock();
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: JSON.stringify({
      id: itemId,
      quantity: qty,
    }),
    dataType: 'json',
    contentType: 'application/json',
    success: async function (cart) {
      await refreshCartSections(cart);
      closeModalOverLay();
      hideUIBlock();
    },
    error: function () {
      hideUIBlock();
    },
  });
}

function fetchTemplateCartPageCart(cart, cart_template, cart_id, is_current_element, options) {
  options = options || {};
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `/?section_id=${cart_template}`,
      success: function (data) {
        const pieceCountFromSection = parsePieceCountFromHtml(data);

        if (is_current_element) {
          const $oldScroll = $(`#${cart_id} .wp-overflow-y-auto`).first();
          const savedScrollTop = $oldScroll.length ? $oldScroll.scrollTop() : 0;

          const expandedKeys = new Set();
          $(`#${cart_id} [data-bundle-line]`).each(function () {
            const btn = this.querySelector('[data-bundle-toggle]');
            if (btn && btn.getAttribute('aria-expanded') === 'true') {
              expandedKeys.add(String(this.getAttribute('data-bundle-key')));
            }
          });

          const $new = $(data);
          if (expandedKeys.size) {
            $new.find('[data-bundle-line]').each(function () {
              const key = String(this.getAttribute('data-bundle-key'));
              if (!expandedKeys.has(key)) return;
              const btn = this.querySelector('[data-bundle-toggle]');
              const ul = this.querySelector('ul.bundle-components');
              if (!btn || !ul) return;
              btn.setAttribute('aria-expanded', 'true');
              ul.style.maxHeight = 'none';
              ul.style.opacity = '1';
              ul.style.marginTop = '';
              const label = btn.querySelector('.bundle-toggle__label');
              const chevron = btn.querySelector('.bundle-toggle__chevron');
              if (label) label.textContent = 'Hide details';
              if (chevron) chevron.style.transform = 'rotate(0deg)';
              const summary = this.querySelector('[data-bundle-summary]');
              if (summary) summary.style.display = 'none';
            });
          }

          const $replacement = $new.find(`#${cart_id}`).first();
          const $current = $(`#${cart_id}`);
          if ($replacement.length && $current.length) {
            const curEl = $current[0];
            const replEl = $replacement[0];
            curEl.innerHTML = replEl.innerHTML;
            for (let i = 0; i < replEl.attributes.length; i++) {
              const attr = replEl.attributes[i];
              if (attr.name !== 'id') curEl.setAttribute(attr.name, attr.value);
            }
          } else if ($current.length) {
            const $found = $new.find(`#${cart_id}`).first();
            $current.html($found.length ? $found.html() : $new.html());
          }

          if (savedScrollTop > 0) {
            requestAnimationFrame(function () {
              const $newScroll = $(`#${cart_id} .wp-overflow-y-auto`).first();
              if ($newScroll.length) {
                $newScroll.scrollTop(savedScrollTop);
              }
            });
          }
        } else {
          const $target = $(data).find(`#${cart_id}`);
          const newSection = $target.html();
          const $current = $(`#${cart_id}`);
          if ($current.length && newSection != null) {
            $current.html(newSection);
          }
        }

        if (!options.skipCountUpdate) {
          updateCartCountDisplays(cart, { pieceCount: pieceCountFromSection });
        }
        if (cart?.item_count == 0) {
          $('.wp-countdown')?.remove();
        }

        resolve(pieceCountFromSection);
      },
      error: function (err) {
        console.error(err);
        reject(err);
      },
    });
  });
}

async function refreshCartSections(cart) {
  const headerPromise = fetchTemplateCartPageCart(
    cart,
    'header-desktop-cart-item',
    'cart_parent_form',
    true,
    { skipCountUpdate: true }
  );

  const drawerPromise =
    cart?.item_count > 0
      ? fetchTemplateCartPageCart(cart, 'cart-drawer-template', 'cart_form', true, {
          skipCountUpdate: true,
        })
      : Promise.resolve(null);

  const cartPagePromise = document.getElementById('cart_line_form')
    ? fetchTemplateCartPageCart(cart, 'cart-template', 'cart_line_form', false, {
        skipCountUpdate: true,
      })
    : Promise.resolve(null);

  const [headerCount, , cartPageCount] = await Promise.all([
    headerPromise,
    drawerPromise,
    cartPagePromise,
  ]);

  // Prefer the cart-page count (most authoritative when on /cart), else header.
  const pieceCount = cartPageCount != null ? cartPageCount : headerCount;
  updateCartCountDisplays(cart, { pieceCount: pieceCount });
}

function reloadCartNumber() {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    contentType: 'application/json',
    success: function (cart) {
      fetchTemplateCartPageCart(cart, 'header-desktop-cart-item', 'cart_parent_form', true, {
        skipCountUpdate: true,
      }).then(function (pieceCount) {
        updateCartCountDisplays(cart, { pieceCount: pieceCount });
      });
    },
    error: function () { },
  });
}

function closeModalOverLay () {
  $(document).ready(function () {
    var $overlayRemove = $('#modal-remove-cart');
    var $overlayPreview = $('#modal-preview');

    $overlayRemove.on('click', function (event) {
      if (event.target === $overlayRemove[0]) {
        closeModalRemove();
      }
    });

    $overlayPreview.on('click', function (event) {
      if (event.target === $overlayPreview[0]) {
        closeModalPreview();
      }
    });
});
}

document.addEventListener('click', function (event) {
  const toggle = event.target.closest('[data-bundle-toggle]');
  if (!toggle) return;

  const targetId = toggle.getAttribute('data-bundle-toggle');
  const list = document.getElementById(targetId);
  if (!list) return;

  const isCollapsing = toggle.getAttribute('aria-expanded') !== 'false';
  toggle.setAttribute('aria-expanded', String(!isCollapsing));

  if (isCollapsing) {
    list.style.transition = 'none';
    list.style.maxHeight = '0px';
    list.style.opacity = '0';
    list.style.marginTop = '0px';
    requestAnimationFrame(function () {
      list.style.transition = '';
    });
  } else {
    list.style.maxHeight = list.scrollHeight + 'px';
    list.style.opacity = '1';
    list.style.marginTop = '';
    list.addEventListener('transitionend', function handler(e) {
      if (e.propertyName !== 'max-height') return;
      list.style.maxHeight = 'none';
      list.removeEventListener('transitionend', handler);
    });
  }

  const label = toggle.querySelector('.bundle-toggle__label');
  const chevron = toggle.querySelector('.bundle-toggle__chevron');
  const bundleLine = toggle.closest('[data-bundle-line]');
  const count = (bundleLine && bundleLine.getAttribute('data-bundle-count')) || list.children.length;

  const summary = bundleLine && bundleLine.querySelector('[data-bundle-summary]');
  if (summary) {
    summary.style.display = isCollapsing ? '' : 'none';
  }

  if (label) {
    label.textContent = (isCollapsing ? 'Show' : 'Hide') + ' details';
  }
  if (chevron) {
    chevron.style.transform = isCollapsing ? 'rotate(180deg)' : 'rotate(0deg)';
  }
});

// --- Bundle component remove ---
function openBundleComponentRemove(el) {
  const row = el.closest('[data-component-row]');
  if (!row) return;

  const parentKey           = row.getAttribute('data-parent-key');
  const componentVariantId  = row.getAttribute('data-component-variant-id');
  const componentIndex      = row.getAttribute('data-component-index');
  const componentImg        = el.getAttribute('data-component-img') || '';

  const elModalRemove   = document.querySelector('#modal-remove-cart');
  const elBtnRemoveCart = document.querySelector('#btn-remove-cart-item');
  if (!elModalRemove || !elBtnRemoveCart) return;

  // store lookup data; sentinel triggers fork in removeCart
  elBtnRemoveCart.setAttribute('data-component-key',          '__pending__');
  elBtnRemoveCart.setAttribute('data-component-parent-key',   parentKey);
  elBtnRemoveCart.setAttribute('data-component-variant-id',   componentVariantId);
  elBtnRemoveCart.setAttribute('data-component-index',        componentIndex);
  elBtnRemoveCart.removeAttribute('data-key');

  const elPreviewImg = elModalRemove.querySelector('img');
  if (elPreviewImg) elPreviewImg.setAttribute('src', componentImg);

  elModalRemove.classList.remove('wp-hidden');
}


var __bundleRemoveInFlight = false;
function endBundleRemove() {
  __bundleRemoveInFlight = false;
}

function removeBundleComponent() {
  const elBtnRemoveCart    = document.querySelector('#btn-remove-cart-item');
  const parentKey          = elBtnRemoveCart.getAttribute('data-component-parent-key');
  const targetVariantId    = parseInt(elBtnRemoveCart.getAttribute('data-component-variant-id'), 10);
  const targetIndex        = elBtnRemoveCart.getAttribute('data-component-index');

  // clean up attrs immediately
  elBtnRemoveCart.removeAttribute('data-component-key');
  elBtnRemoveCart.removeAttribute('data-component-parent-key');
  elBtnRemoveCart.removeAttribute('data-component-variant-id');
  elBtnRemoveCart.removeAttribute('data-component-index');

  if (__bundleRemoveInFlight) {
    return;
  }
  __bundleRemoveInFlight = true;

  const parentVariantId = parentKey ? parseInt(String(parentKey).split(':')[0], 10) : null;

  showUIBlock();

  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {
      let parentLine = null;
      for (const it of cart.items) {
        if (it.key === parentKey) { parentLine = it; break; }
      }
      if (!parentLine && parentVariantId) {
        for (const it of cart.items) {
          const props = it.properties || {};
          const isMain = props['_bundle_role'] === 'main' || String(props['_bundle_item_index']) === '0';
          if (it.variant_id === parentVariantId && isMain) { parentLine = it; break; }
        }
      }
      const bundleGroup = parentLine && parentLine.properties
        ? (parentLine.properties['_bundle_group'] || null)
        : null;

      const candidates = cart.items.filter(function(item) {
        const props = item.properties || {};
        return item.variant_id === targetVariantId
          && String(props['_bundle_item_index']) === String(targetIndex);
      });

      
      let componentLine = null;
      if (candidates.length === 1) {
        componentLine = candidates[0];
      } else if (candidates.length > 1) {
        if (bundleGroup) {
          componentLine = candidates.find(function(item) {
            return (item.properties || {})['_bundle_group'] === bundleGroup;
          }) || null;
        }
        if (!componentLine) componentLine = candidates[0];
      }

      if (!componentLine) {
       
        if (parentLine) {
          reconcileBundleMain(parentLine, targetVariantId);
          return;
        }
        hideUIBlock();
        console.warn('[bundle-component] line not found', {
          targetVariantId: targetVariantId,
          targetIndex: targetIndex,
          bundleGroup: bundleGroup,
          parentKey: parentKey,
          candidates: candidates.length,
        });
        reloadCartPageSections();
        return;
      }

      
      removeAddonAndReconcile(componentLine, parentLine, targetVariantId);
    },
    error: function(err) {
      endBundleRemove();
      hideUIBlock();
      console.error('[bundle-component] /cart.js fetch failed', err);
    },
  });
}


function removeAddonAndReconcile(componentLine, parentLine, addonVariantId) {
  const parentVariantId = parentLine ? parentLine.variant_id : null;
  const parentGroup = parentLine && parentLine.properties
    ? (parentLine.properties['_bundle_group'] || null)
    : null;
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: JSON.stringify({ id: componentLine.key, quantity: 0 }),
    dataType: 'json',
    contentType: 'application/json',
    success: function(cart) {
      
      let freshMain = null;
      if (cart && Array.isArray(cart.items)) {
        if (parentVariantId) {
          for (const it of cart.items) {
            const p = it.properties || {};
            const isMain = p['_bundle_role'] === 'main' || String(p['_bundle_item_index']) === '0';
            const groupOk = !parentGroup || p['_bundle_group'] === parentGroup;
            if (it.variant_id === parentVariantId && isMain && groupOk) { freshMain = it; break; }
          }
        }
      }
      reconcileBundleMain(freshMain, addonVariantId);
    },
    error: function(err) {
      endBundleRemove();
      hideUIBlock();
      console.error('[bundle-component] failed to remove add-on line', err);
    },
  });
}


function reconcileBundleMain(parentLine, addonVariantId) {
  if (!parentLine || !parentLine.properties || !parentLine.properties['_bundle_components']) {
    reloadCartPageSections();
    return;
  }

  let components;
  try {
    components = JSON.parse(parentLine.properties['_bundle_components']);
  } catch (e) {
    reloadCartPageSections();
    return;
  }
  if (!Array.isArray(components)) {
    reloadCartPageSections();
    return;
  }

  const gid = window.SHOPIFY_VARIANT_GID_PREFIX + addonVariantId;
  const next = components.filter(function(c) {
    return c && c.id !== gid && String(c.id) !== String(addonVariantId);
  });

  // nothing changed -> just refresh
  if (next.length === components.length) {
    reloadCartPageSections();
    return;
  }

  const newProps = Object.assign({}, parentLine.properties, {
    _bundle_components: JSON.stringify(next),
  });

  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: JSON.stringify({ id: parentLine.key, quantity: parentLine.quantity, properties: newProps }),
    dataType: 'json',
    contentType: 'application/json',
    success: function(cart) {
      // change.js returns the full updated cart -> render directly, no extra GET.
      renderCartSections(cart);
    },
    error: function(err) {
      // even if reconcile fails, refresh so UI reflects the add-on removal
      console.error('[bundle-component] failed to reconcile main _bundle_components', err);
      reloadCartPageSections();
    },
  });
}


function renderCartSections(cart) {
  refreshCartSections(cart)
    .then(function () {
      endBundleRemove();
      closeModalOverLay();
      hideUIBlock();
    })
    .catch(function () {
      endBundleRemove();
      closeModalOverLay();
      hideUIBlock();
    });
}

// Re-fetch & re-render the cart page + header cart sections from server truth.
function reloadCartPageSections() {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {
      renderCartSections(cart);
    },
    error: function() {
      endBundleRemove();
      hideUIBlock();
    },
  });
}

window.addEventListener('pageshow', function (event) {
  var navEntry = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  var isBackForward = navEntry && navEntry.type === 'back_forward';

  // Only act when the page is served from bfcache (event.persisted) OR reached via a
  // history back/forward. The latter may rebuild the page from stale HTTP-cached HTML,
  // so the server-rendered cart icon + drawer can show a pre-update quantity.
  if (!event.persisted && !isBackForward) return;

  // Instantly paint the last-known count from cache so the icon doesn't visibly jump
  // from the stale server-rendered value to the fresh one once the AJAX below resolves.
  var cached = NaN;
  try { cached = parseInt(localStorage.getItem('cart_piece_count'), 10); } catch (e) {}
  if (!isNaN(cached) && typeof updateCartCountDisplays === 'function') {
    updateCartCountDisplays({ item_count: cached }, { pieceCount: cached });
  }

  var onCartPage = document.getElementById('cart_line_form') || location.pathname === '/cart';
  if (onCartPage) {
    if (typeof reloadCartPageSections === 'function') reloadCartPageSections();
    return;
  }

  // Non-cart page: the header section (which nests the cart drawer) can be stale —
  // re-fetch it from server truth so the icon count and drawer quantities are correct.
  if (typeof reloadCartNumber === 'function') reloadCartNumber();
});
